import { Component, inject, ViewEncapsulation } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SignInData, TokenService } from '@services/token-service';
import { FormsModule } from '@angular/forms';
import { I18nPlaceholderDirective } from '../../directives/i18n.directives';
import { IconDirective } from '../../directives/icon.directive';
import { TranslateModule } from '@ngx-translate/core';
import { CopyrightComponent } from '../copyright/copyright.component';
import { PublicGraphqlService } from '@services/public-graphql.service';
import { CookieDomainService } from '@services/cookie-domain.service';
import { take } from 'rxjs';

@Component({
  selector: 'lv-login',
  templateUrl: 'login-form.component.html',
  styleUrls: ['login-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [FormsModule, I18nPlaceholderDirective, IconDirective, TranslateModule, CopyrightComponent, RouterModule]
})
export class LoginFormComponent {
  private tokenService = inject(TokenService);
  private publicGraphqlService = inject(PublicGraphqlService);
  private cookieDomainService = inject(CookieDomainService);
  private router = inject(Router);

  user: SignInData = { email: '', password: '' };

  login() {
    this.publicGraphqlService.cookieDomain$.pipe(take(1)).subscribe({
      next: (domain) => {
        if (domain) {
          this.cookieDomainService.setCookieDomain(domain);
        }
        this.performLogin();
      },
      error: (err) => console.log('error', err)
    });
  }

  private performLogin() {
    this.tokenService
      .signIn(this.user)
      .pipe(take(1))
      .subscribe({
        next: () => {
          let path = this.tokenService.redirectTo() || '/';
          if (path.includes('auth')) {
            path = '/';
          }
          this.router.navigateByUrl(path);
        },
        error: (err) => console.log(err)
      });
  }
}
